import React from 'react';
import BackButton from '@/components/BackButton';

const Compliance: React.FC = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <BackButton />
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto prose prose-slate dark:prose-invert">
          <h1>Compliance</h1>
          
          <h2>Regulatory Compliance</h2>
          <p>
            NEXUS Phish maintains strict compliance with various regulatory requirements and industry standards:
          </p>

          <h3>Data Protection</h3>
          <ul>
            <li>
              <strong>GDPR Compliance</strong>
              <p>Adherence to EU General Data Protection Regulation requirements.</p>
            </li>
            <li>
              <strong>CCPA Compliance</strong>
              <p>California Consumer Privacy Act compliance for US users.</p>
            </li>
            <li>
              <strong>PDPA Compliance</strong>
              <p>Personal Data Protection Act compliance for Asian regions.</p>
            </li>
          </ul>

          <h3>Security Standards</h3>
          <ul>
            <li>
              <strong>ISO 27001</strong>
              <p>Information security management system certification.</p>
            </li>
            <li>
              <strong>SOC 2 Type II</strong>
              <p>Security, availability, and confidentiality controls.</p>
            </li>
            <li>
              <strong>PCI DSS</strong>
              <p>Payment Card Industry Data Security Standard compliance.</p>
            </li>
          </ul>

          <h2>Compliance Requirements</h2>
          <p>
            Users must comply with:
          </p>
          <ul>
            <li>Local data protection laws</li>
            <li>Industry-specific regulations</li>
            <li>Security testing guidelines</li>
            <li>Ethical hacking standards</li>
          </ul>

          <h2>Audit & Reporting</h2>
          <p>
            Our compliance measures include:
          </p>
          <ul>
            <li>Regular security audits</li>
            <li>Compliance monitoring</li>
            <li>Incident reporting</li>
            <li>Documentation maintenance</li>
          </ul>

          <h2>Training & Awareness</h2>
          <p>
            We provide:
          </p>
          <ul>
            <li>Compliance training materials</li>
            <li>Security awareness programs</li>
            <li>Regular updates on regulations</li>
            <li>Best practice guidelines</li>
          </ul>

          <h2>Contact Compliance Team</h2>
          <p>
            For compliance-related inquiries:
          </p>
          <ul>
            <li>Email: compliance@nexuscipherguard.com</li>
            <li>Phone: +91 XXXXXXXXXX</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Compliance;